import React, { Component } from 'react';

import questionImage from '../../img/img-clipart-wwd-question.png';
import percentImage from '../../img/img-clipart-wwd-percent.png';
import moneyImage from '../../img/img-clipart-wwd-money.png';

  const ColoredLine = ({ color }) => (
    <hr style={{
            color: color,
            backgroundColor: color,
            height: 1,
            margin: 'calc(4vw)'
        }}
    />
);

//COVID-19 cases from 31st December 2019 to 21st April 2020, Total 2,435,876 - Active 1,629,268, Fatal 167,369 people worldwide | Hungry 821.6 million people worldwide | Obese 672 million adults worldwide | Poor 736 million people worldwide | Homeless 150 million people worldwide | Food Wastage 
//1.3 billion tons worldwide | Heavy Stomach Symptoms no official numbers, common, urgent | Difficult to Determine Legitimate Charities 70% of donors in the US | Amount Lost to Fake Charities in Australia in 2019 $287 234 | Charity Tax Shelter Scam in Canada over $7 billion worth of tax claims denied

//<p>A percentage of your purchase is immediately contributed to helping people in need through our community partners when using our app. 
//No extra money is required as contribution. Purchase (+ tip) as usual.</p>

//<ColoredLine color= "gray" />
//<font color="gray">Platform for Meal-generated Transparent Donations - <a href="https://goo.gl/forms/68rt37pElAEhk3M82"
//target="_blank" rel="noopener noreferrer">Create an Account, It's Free</a></font> 
//<ColoredLine color="gray"/>

//<ColoredLine color= "gray" />
//<font color="gray">A percentage of your purchase is immediately contributed to helping people in need through our community partners when using our app. 
//No extra money is required as contribution. Purchase (+ tip if you like) as usual.</font>
//<ColoredLine color="gray"/>

//<ColoredLine color= "gray" />
//<font color="gray">A percentage of your purchase is immediately contributed to helping people in need through our community partners when using our app (access our demo for now). 
//No extra money is required as contribution. Purchase (+ tip if you can) as usual.</font>
//<ColoredLine color="gray"/>

//<ColoredLine color= "gray" />
//<font color="gray">A percentage of your purchase is immediately contributed to helping people in need through our community partners when using our app (<a href="https://goo.gl/forms/68rt37pElAEhk3M82" target="_blank" rel="noopener noreferrer">access our demo for now</a>). 
//No extra money is required as contribution. Purchase (+ tip if you can) as usual.</font>
//<ColoredLine color="gray"/>

//<h3 className="BlurbText">
  //2. Help Someone - Contribute a portion of what you pay for buying your meal to your preferred local charity where you are located.
//</h3>


//<div className = "RightCircleDiv">
  //<img className = "RightBlurbImages" id = "wwdRightBlurb" src={require('../../img/img-clipart-wwd-question.png')} alt="question mark"/>
//</div>

//<div className="LeftCircleDiv">
  //<img className = "LeftBlurbImages" id = "wwdLeftBlurb" src={require('../../img/img-clipart-wwd-percent.png')} alt="money"/>
//</div>

//<div className="RightCircleDiv">
  //<img className = "RightBlurbImages" id = "wwdRightBlurb" src={require('../../img/img-clipart-wwd-money.png')} alt="percentage"/>
//</div>

//<ColoredLine color= "gray" />
//<font color="gray">A percentage of your purchase is immediately donated to helping people in need through our community partners when using our app (<a href="https://goo.gl/forms/68rt37pElAEhk3M82" target="_blank" rel="noopener noreferrer">access our demo for now</a>). 
//No extra money is required as donation. Purchase (+ tip if you can) as usual.</font>
//<ColoredLine color="gray"/>

//<ColoredLine color= "gray" />
//<font color="gray">A percentage of your purchase is immediately donated to helping people in need through our community partners when using our app (<a href="https://t.me/joinchat/UftQDdJtd4e-_uZg" target="_blank" rel="noopener noreferrer">access our demo for now</a>). 
//No extra money is required as donation. Purchase (+ tip if you can) as usual.</font>
//<ColoredLine color="gray"/>

class Blurbs extends Component {

  render() {
    return (
      <div>

        <h1 id = "title" >
          what we do | how it works
        </h1>


        <div id="catchDiv" className = "blurbDivs">

          <h3 className ="Catch">
          <br/>
          <p>Improve the lives of people locally, and around the world by mobilizing the able to help those in need.</p>
          <ColoredLine color= "gray" />
          <font color="gray">A percentage of your purchase is immediately donated to helping people in need through our community partners when using our app (<a href="https://youtu.be/sx88xGMDit0" target="_blank" rel="noopener noreferrer">sneak peek 1</a>). 
          No extra money is required as donation. Purchase (+ tip if you can) as usual.</font>
          <ColoredLine color="gray"/>
          </h3>

        </div>

        <div className = "blurbDivs">

          <div className = "RightCircleDiv">
            <img className = "RightBlurbImages" id = "wwdRightBlurb" src={questionImage} alt="question mark"/>
          </div>

          <div className = "BlurbContainer">
            <h3 className="BlurbText">
            1. Order Your Meal - Choose your favorite meal from your preferred meal provider where you are located.
            </h3>
          </div>

        </div>

        <div className = "blurbDivs">

          <div className = "BlurbContainer">
            <h3 className="BlurbText">
            2. Help Someone - Donate a portion of what you pay for buying your meal to your preferred local charity where you are located.
            </h3>
          </div>
      
          <div className="LeftCircleDiv">
            <img className = "LeftBlurbImages" id = "wwdLeftBlurb" src={percentImage} alt="money"/>
          </div>

        </div>

        <div className = "blurbDivs">

          <div className="RightCircleDiv">
            <img className = "RightBlurbImages" id = "wwdRightBlurb" src={moneyImage} alt="percentage"/>
          </div>

          <div className = "BlurbContainer">
            <h3 className="BlurbText">
            3. Dig In, Have An Awesome Day - Enjoy your favorite meal where you are located or skip the line for a dine-in or pick-up or catering experience.
            </h3>
          </div>

        </div>

      </div>
    );
  }
}

export default Blurbs;
